module.exports = __webpack_public_path__ + "img/Play_75x75.3e845583.png";